import { render } from "./MediaCard.vue?vue&type=template&id=49c58e82&scoped=true"
import script from "./MediaCard.vue?vue&type=script&lang=js"
export * from "./MediaCard.vue?vue&type=script&lang=js"

import "./MediaCard.vue?vue&type=style&index=0&id=49c58e82&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49c58e82"]])

export default __exports__